import { API_URL } from "@/_plugins/axios";
import withoutWatchersMixin from "@/_plugins/withoutWatchersMixin";
import debounce from "lodash/debounce";
import Multiselect from "vue-multiselect";
import Form from "@/_plugins/form";
import Pagination from "laravel-vue-pagination";
import HasError from "@/components/HasError";
import i18n from "@/_plugins/i18n";
import DetailsModal from "@/components/DetailsModal";
import { mapGetters } from "vuex";

export default {
  mixins: [withoutWatchersMixin],
  name: "EquipmentDocument",
  components: {
    // HelloWorld,
    Multiselect,
    Pagination,
    HasError,
    DetailsModal,
    // Skeleton,
  },
  data() {
    return {
      usersEquipment: [],
      subcategoriesOptions: [],
      users: [],
      history: {},
      searchDropdown: false,
      equipment: [],
      equipmentCategories: [],
      subcategories: [],
      sectors: [],
      selectedUser: null,
      item: null,
      selectedEquipment: [],
      form: new Form({
        user_id: null,
        equipment_id: [],
      }),
      modalImages: [],
      value: null,
      currentPage: 1,
      loading: false,
      loadingHistory: false,
      loadingExport: false,
      modalTitle: "Dodaj novi karton",
      filters: {
        trashed: true,
        category: 0,
        subcategory: 0,
        sector: 0,
        date_range: "",
      },
      baseurl: process.env.VUE_APP_BASE_BACKEND_URL,
    };
  },
  methods: {
    changeSubcategory() {
      this.filters.subcategory = 0;
      let subcategories = [];
      this.equipmentCategories.filter((item) => {
        if (item.id === this.filters.category)
          subcategories = item.subcategories;
      }),
        (this.subcategoriesOptions = [
          { id: 0, name: "Sve potkategorije" },
          ...subcategories,
        ]);
    },
    resetFilters() {
      this.filters.category = 0;
      this.filters.subcategory = 0;
      this.filters.sector = 0;
      this.filters.date_range = "";
    },
    selectEquipment() {
      this.form.equipment_id = [];
      if (!this.item) {
        this.selectedEquipment.forEach((item) => {
          this.form.equipment_id.push(item.id);
        });
      } else {
        this.form.equipment_id.push(this.selectedEquipment.id);
      }
    },
    unrented() {
      this.item = null;
      this.closeModal();
      this.getAllEquipment();
      this.getEquipmentDocuments();
    },
    detailsModalClosed() {
      this.item = null;
    },
    getAllCategories() {
      API_URL.get("category").then((response) => {
        this.equipmentCategories = response.data.data;
      });
    },
    getSubcategories() {
      API_URL.get("subcategory").then((response) => {
        this.subcategories = response.data;
      });
    },
    getAllSectors() {
      API_URL.get("sector").then((response) => {
        this.sectors = response.data.data;
      });
    },
    edit(i) {
      this.item = i;
      this.form.user_id = i.user_detail.id;
      this.form.rented_state = i.rented_state;
      this.form.equipment_id.push(i.equipment_detail.id);
      this.selectedEquipment = i.equipment_detail;
      this.selectedUser = i.user_detail;
      this.$bvModal.show("modal-1");
    },
    details(i) {
      this.item = i;
      this.$bvModal.show("details");
    },
    unrent(id, state) {
      this.loading = true;
      let rs = prompt(`Razduzeno stanje (${state})`);
      // if (rs) {
      API_URL.delete(`unrent-equipment/${id}/${rs ? rs : state}`).then(() => {
        this.$toast.success(i18n.tc("notifications.success"));
        this.currentPage = 1;
        this.loading = false;
        this.getEquipmentDocuments();
        this.getAllEquipment();
      });
      // } else {
      //   this.loading = false;
      //   this.$toast.warning("Morate unijeti razduzeno stanje");
      // }
    },
    gallery(item) {
      this.modalImages = item.images; // Set modalImages to the images of the clicked itemconsole.log()
      this.$bvModal.show("modal-2");
    },
    closeModal() {
      this.form.reset();
      this.item = null;
      this.selectedEquipment = [];
      this.selectedUser = null;
    },
    getAllUsers() {
      API_URL.get("users/all").then((response) => {
        this.users = response.data;
      });
    },
    getAllEquipment() {
      API_URL.get("available-equipment").then((response) => {
        this.equipment = response.data.data;
        // this.equipment.forEach((item) => {
        //   item.name = `${item.name} (${item.state})`;
        // })
      });
    },
    closeSearchDropdown() {
      this.searchDropdown = false;
    },
    getEquipmentDocuments() {
      this.loading = true;
      API_URL.get("users-equipment-history", {
        params: {
          page: this.currentPage,
          ...this.filters,
        },
      }).then((response) => {
        this.usersEquipment = response.data;
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapGetters({
      exporting: "exporting",
    }),
    categoriesOptions() {
      return [{ id: 0, name: "Sve kategorije" }, ...this.equipmentCategories];
    },
    // subcategoriesOptions() {
    //   return [{ id: 0, name: "Sve potkategorije" }, ...this.subcategories];
    // },
    sectorOptions() {
      return [{ id: 0, name: "Svi sektori" }, ...this.sectors];
    },
    resultsCount() {
      return this.usersEquipment?.data?.length;
    },
  },
  watch: {
    filters: {
      deep: true,
      immediate: false,
      // eslint-disable-next-line no-unused-vars
      handler: debounce(function (value) {
        this.$withoutWatchers(() => (this.currentPage = 1));
        this.getEquipmentDocuments();
      }, 250),
    },
    currentPage() {
      this.getEquipmentDocuments();
    },
  },
  mounted() {
    this.getEquipmentDocuments();
    this.getAllUsers();
    this.getAllEquipment();
    this.getAllCategories();
    this.getAllSectors();
    this.$emit("loadBreadcrumbLink", {
      pageName: "Isotrija zaduženja",
    });
  },
};
